<template>
  <el-dropdown
    trigger="hover"
    :hide-timeout="200"
    :placement="placement"
    :popper-class="resolvedPopperClass"
    @visible-change="visible => emit('visible-change', visible)"
    @command="handleCommand"
  >
    <slot />

    <template #dropdown>
      <el-dropdown-menu :style="{ width: `${itemWidth}px` }" class="p-0px">
        <el-dropdown-item
          v-for="item in items"
          :key="item.key"
          :command="item.key"
          :class="[item.class, { 'bg-d': item.active }]"
          :style="{ width: `${itemWidth}px` }"
          class="h-44px box-border"
        >
          <slot name="item" :item="item">
            <Row class="gap-6px" y="c">
              <span>{{ item.label }}</span>
              <span
                v-if="item.badge"
                class="rounded-4px bg-06F0C6 px-4px py-1px text-10px lh-12px weight-600 uppercase text-16151A"
              >
                {{ item.badge }}
              </span>
            </Row>
          </slot>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
const emit = defineEmits(['select', 'visible-change'])

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  placement: {
    type: String,
    default: 'bottom-start',
  },
  popperClass: {
    type: String,
    default: '',
  },
  itemWidth: {
    type: Number,
    default: 200,
  },
})

const resolvedPopperClass = $computed(() => [
  'dropdown-no-arrow',
  'HoverDropdownMenu-popper',
  props.popperClass,
].filter(Boolean).join(' '))

const handleCommand = key => emit('select', key)
</script>

<style scoped lang="scss">
:global(.HoverDropdownMenu-popper.el-popper) {
  width: 224px;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 12px;
}

:global(.HoverDropdownMenu-popper .el-dropdown-menu) {
  margin: 0;
  padding: 0 !important;
}

:global(.HoverDropdownMenu-popper .el-scrollbar__view.el-dropdown__list) {
  margin: 0;
  padding: 0 !important;
}

:global(.HoverDropdownMenu-popper .el-dropdown-menu__item) {
  min-height: 44px;
  height: 44px !important;
  box-sizing: border-box;
  border-radius: 4px;
}

:global(.HoverDropdownMenu-popper .el-dropdown-menu__item:not(.is-disabled):hover),
:global(.HoverDropdownMenu-popper .el-dropdown-menu__item:not(.is-disabled):focus) {
  background-color: var(--f9) !important;
}
</style>
